import Vue from 'vue'
import App from './App.vue'
import store from './store'
import i18n from './locales'
import './assets/scss/app.scss'

import { TweenMax, TimelineLite, Power2, Elastic, CSSPlugin } from "gsap";
import { ScrollToPlugin } from "gsap/all";

Vue.config.productionTip = false

new Vue({
    store,
    i18n,
    render: function (h) { return h(App) }
}).$mount('#app')
